var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortArrowDownPrimary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0005 7C12.5528 7 13.0005 7.44771 13.0005 8L13.0005 15.5381L15.2988 13.267C15.6887 12.8486 16.3201 12.8493 16.7091 13.2686C16.9034 13.478 17.0005 13.7522 17.0005 14.0263C17.0005 14.2554 16.9327 14.4844 16.7971 14.6756L16.7077 14.7855L14.4061 17.0597C13.7771 17.7362 12.9351 18.0477 12.1097 17.9941C12.0739 17.998 12.0374 18 12.0005 18C11.9635 18 11.927 17.998 11.891 17.9941C11.0656 18.0478 10.2233 17.7363 9.59433 17.0597L7.29274 14.7855L7.20327 14.6756C7.06771 14.4844 6.99991 14.2554 6.99991 14.0263C6.99991 13.7522 7.09704 13.478 7.2913 13.2686C7.68032 12.8493 8.31171 12.8486 8.70158 13.267L11.0005 15.5386L11.0005 8C11.0005 7.44771 11.4482 7 12.0005 7Z",
    fill: "#2D6CE6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortArrowDownPrimary);
export default __webpack_public_path__ + "static/media/sort-arrow-down-primary.462f575de7db5c7f4ec16c5d5a9a22c6.svg";
export { ForwardRef as ReactComponent };